<template>
  <div class="col-12">
    <div class="grid p-0">
      <div class="col-12 md:col-3 p-0 align-self-center">
        <span class=" appointment-time px-3 ">
          <p><strong>{{ time }}</strong></p>
        </span>
      </div>
      <div class="col-12 md:col-3">
        <p>{{ $t('entity.lineId.mainVenue') }} : </p>
        <p><strong>{{ $i18n.locale === 'fr' ? immediateTagging.mainVenue.frenchWording : immediateTagging.mainVenue.englishWording }}</strong></p>
      </div>

      <div class="col-12 md:col-6 text-right align-self-center">
        <Button
          :label="$t('action.details')"
          icon="pi pi-eye"
          class="p-button-rounded p-button-outlined col-12 md:col-3"
          @click="onClickDetails"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "primevue/button";
import {convertDateStringToTimeLocaleString} from "@/shared/utils/dateTimeUtils";

export default {
  name: 'ImmediateTaggingOverview',
  components: {Button},
  props: {
    immediateTagging: {
      type: Object,
      required: true
    }
  },
  computed: {
    time() {
      return convertDateStringToTimeLocaleString(this.immediateTagging.creationDate, this.$i18n.locale);
    }
  },
  methods: {
    onClickDetails() {
      this.$router.push({
        name: 'immediateTaggingDetail',
        params: {
          id: this.immediateTagging.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.appointment-time {
  background-color: $light-grey;
  display: inline-block;
}
</style>
